import React, {ReactElement, useState} from 'react';
import {useIntl} from 'react-intl';
import {EyeIcon, EyeCrossedIcon} from '../../Icons';
import Field from '../Field/Field';
import {Field as FieldType} from '../types';
import './Password.scss';

interface Props extends Omit<FieldType, 'placeholder'> {
  maxLength?: number;
  minLength?: number;
}

function Password({
  assistiveMessage = '',
  errorMessage = '',
  label,
  maxLength = 128,
  minLength = 8,
  name,
  onChange,
  onBlur = () => {
    /* noop */
  },
  value,
  warningMessage = '',
  isDisabled,
}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const [isShowingPassword, setIsShowingPassword] = useState<boolean>(false);
  const toggleShowPassword = () => setIsShowingPassword(!isShowingPassword);

  return (
    <Field
      assistiveMessage={assistiveMessage}
      errorMessage={errorMessage}
      label={label}
      name={name}
      warningMessage={warningMessage}
      isDisabled={isDisabled}
    >
      <div className="password">
        <input
          id={name}
          maxLength={maxLength}
          minLength={minLength}
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={formatMessage({id: 'phoenix.fields.password.placeholder'})}
          type={isShowingPassword ? 'text' : 'password'}
          value={value}
          disabled={isDisabled}
        />
        <button
          className="password__showHideButton"
          type="button"
          onClick={toggleShowPassword}
          title={formatMessage({id: 'phoenix.fields.password.displayTitle'})}
          disabled={isDisabled}
          data-testid="control.passwordMask.showHide"
        >
          {isShowingPassword ? <EyeCrossedIcon /> : <EyeIcon />}
        </button>
      </div>
    </Field>
  );
}

export default Password;
